module.exports = __webpack_public_path__ + "static/media/window.5641af77.png";